<script lang="ts" setup>
import ProfileMenuContent from '@exchange/libs/account/ui/src/libs/ProfileMenuContent.vue';
import { partnersService } from '@exchange/libs/partners/service/src';

import HeaderMenu from './HeaderMenu.vue';

const { showPartnersDot } = partnersService;
</script>

<template>
  <header-menu
    :class="['panda-menu', { 'show-green-dot': showPartnersDot }]"
    show-arrow="show-arrow"
    testid="account-menu"
  >
    <template #default>
      <x-button
        class="panda-menu__user-avatar"
        variant="tertiary"
        size="2xs"
      >
        <ot-icon
          class="panda-menu__icon"
          name="user-square"
        />
      </x-button>
    </template>
    <template #menu-content="{ closeMenu }">
      <profile-menu-content
        class="panda-menu__content"
        :close-menu="closeMenu"
      />
    </template>
  </header-menu>
</template>

<style lang="scss">
.panda-menu {
  color: rgb(var(--v-theme-text-secondary)) !important;

  &__icon {
    display: block;
    width: 20px;
    height: 20px;
  }

  &__content {
    width: 290px;
    padding: 16px;
  }

  &.show-green-dot::after {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 10px;
    height: 10px;
    border: solid 2px rgb(var(--v-theme-elevation-0));
    border-radius: 100%;
    background-color: rgb(var(--v-theme-primary));
    content: '';
  }
}
</style>
